export interface FAQItem {
  question: string;
  answer: string;
}

export const faqData: FAQItem[] = [
  {
    question: '玖玖视频是否需要付费？',
    answer: '玖玖视频是一款完全免费的在线视频平台，所有视频资源均可免费观看。我们致力于为用户提供高质量的视频内容，不收取任何观看费用。部分独家内容可能需要简单注册后观看。',
  },
  {
    question: '支持哪些设备观看？',
    answer: '玖玖视频支持全平台观看，包括电脑（Windows/Mac）、平板（iPad/Android Pad）和手机（iOS/Android）。您可以通过浏览器直接访问，无需下载任何客户端，随时随地畅享高清视频内容。',
  },
  {
    question: '视频画质如何？最高支持多少分辨率？',
    answer: '玖玖视频采用先进的视频编码和CDN加速技术，支持从流畅（360P）到超清（1080P）甚至4K超高清画质。系统会根据您的网络状况自动选择最佳画质，您也可以手动调整以获得最佳观看体验。',
  },
  {
    question: '如何搜索我想看的视频？',
    answer: '您可以通过首页顶部的搜索框输入关键词进行搜索，也可以使用分类浏览功能按类别查找感兴趣的视频。我们还提供热门推荐和个性化推荐功能，帮助您发现更多优质内容。',
  },
  {
    question: '视频加载慢或卡顿怎么办？',
    answer: '如果遇到视频加载缓慢或播放卡顿，建议您：1）检查网络连接是否稳定；2）尝试降低视频画质；3）关闭其他占用带宽的应用；4）刷新页面重试。我们的技术团队持续优化CDN节点，确保全国各地的用户都能流畅观看。',
  },
  {
    question: '如何联系我们或反馈问题？',
    answer: '您可以通过「关于我们」页面中的联系方式与我们取得联系，包括电子邮件、在线反馈表单和客服热线。我们非常重视每一位用户的意见和建议，通常会在24小时内回复您的反馈。',
  },
];